<template>
  <v-navigation-drawer
    v-if="displayWalletMenu"
    v-model="displayWalletMenu"
    class="wallet-nav"
    ref="walletNavDrawer"
    temporary
    fixed
    right
    width="500"
    :stateless="walletMenuScreen == 'display-add-to-mobile'"
  >
    <v-card elevation="0" rounded="0" v-if="walletMenuScreen == 'main'">
      <DrawerToolbar :title="walletTitle" @close="closeWallet" />
      <v-row no-gutters class="mb-3 mt-1">
        <MarqetaWidgetManager
          class="pa-2"
          ref="marqeta-widget"
          :isModal="true"
          @close-wallet="closeWallet"
          @scroll-top="scrollToTopOfWalletDrawer"
        />
      </v-row>
    </v-card>

    <AddToMobileWalletInstructions v-else-if="walletMenuScreen == 'display-add-to-mobile'" />

    <v-card elevation="0" rounded="0" v-else-if="walletMenuScreen == 'display-virtual'">
      <MarqetaVirtualCard
        v-if="walletMenuScreen == 'display-virtual' && displayWalletMenu"
        @get-cards="getCards"
        @reset="resetWalletScreen"
        @scrollToTop="scrollToTopOfWalletDrawer"
      />
    </v-card>

    <v-card elevation="0" rounded="0" v-else-if="walletMenuScreen == 'card-activation'">
      <MarqetaActivateCard
        v-if="walletMenuScreen == 'card-activation' && displayWalletMenu"
        @get-cards="getCards"
        @reset="resetWalletScreen"
        @scrollToTop="scrollToTopOfWalletDrawer"
      />
    </v-card>
    <v-card elevation="0" rounded="0" v-else-if="walletMenuScreen == 'card-pin'">
      <MarqetaCreatePIN
        v-if="walletMenuScreen == 'card-pin' && displayWalletMenu"
        @get-cards="getCards"
        @reset="resetWalletScreen"
        @scrollToTop="scrollToTopOfWalletDrawer"
      />
    </v-card>
    <v-card elevation="0" rounded="0" v-else-if="walletMenuScreen == 'update-user'">
      <MarqetaEditUser
        v-if="walletMenuScreen == 'update-user' && displayWalletMenu"
        @reset="resetWalletScreen"
        @scrollToTop="scrollToTopOfWalletDrawer"
      />
    </v-card>
    <MarqetaFooter :column="true" />
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import MarqetaWidgetManager from "@/components/wallet/MarqetaWidgetManagerV2.vue";
import MarqetaVirtualCard from "@/components/wallet/MarqetaVirtualCard.vue";
import MarqetaActivateCard from "@/components/wallet/MarqetaActivateCard.vue";
import MarqetaCreatePIN from "@/components/wallet/MarqetaCreatePIN.vue";
import MarqetaEditUser from "@/components/wallet/MarqetaEditUser.vue";
import MarqetaFooter from "@/components/wallet/MarqetaFooter.vue";
import AddToMobileWalletInstructions from "@/components/wallet/AddToMobileWalletInstructions.vue";
import DrawerToolbar from "@/components/generic/DrawerToolbar.vue";

export default {
  name: "WalletDrawer",
  components: {
    DrawerToolbar,
    MarqetaWidgetManager,
    MarqetaVirtualCard,
    MarqetaActivateCard,
    MarqetaCreatePIN,
    MarqetaEditUser,
    MarqetaFooter,
    AddToMobileWalletInstructions,
  },
  computed: {
    ...mapState(["userProfile", "walletMenuScreen", "sourceWalletPage"]),
    walletTitle() {
      return `${this.userProfile.firstName}'s Wallet`;
    },
    displayWalletMenu: {
      get() {
        return this.$store.state.displayWalletMenu;
      },
      set(state) {
        if (state !== this.$store.state.displayWalletMenu) {
          this.$store.dispatch("setDisplayWalletMenu", state);
        }
      },
    },
    walletScreen: {
      get() {
        return this.walletMenuScreen;
      },
      set(newValue) {
        this.$store.dispatch("setWalletMenuScreen", newValue);
      },
    },
  },
  methods: {
    closeWallet() {
      this.$store.dispatch("setDisplayWalletMenu", false);
    },
    getCards() {
      // We fetch their current cards and hide things based on state
      this.$store.dispatch("setMarqeta");
    },
    resetWalletScreen() {
      if (this.sourceWalletPage == "wallet" || this.sourceWalletPage == "programs") {
        this.displayWalletMenu = false;
        // We have to set the source page so we know when they click back, it closes the drawer
        this.$store.dispatch("setSourceWalletPage", null);
        this.walletScreen = "main";
      } else {
        this.walletScreen = "main";
      }
    },
    scrollToTopOfWalletDrawer() {
      var navDrawerContent = this.$refs["walletNavDrawer"].$el.querySelector(
        "div.v-navigation-drawer__content"
      );
      navDrawerContent.scrollTop = 0;
    },
  },
};
</script>

<style scoped>
.wallet-nav .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}

/* Hides gray background when clicking v-card */
.wallet-nav >>> .v-card--link:before {
  background: none;
}
</style>
